import { AutoAwesome } from '@mui/icons-material';
import { Chip, Stack } from '@mui/material';

export const AiChip = () => (
  <Chip
    sx={({ palette }) => ({
      background: palette.primary.gradient,
      color: 'white',
      '& svg': { color: 'white !important' },
    })}
    label={
      <Stack direction="row" alignItems="center" gap={0.5}>
        Recomendado por IA
        <AutoAwesome />
      </Stack>
    }
  />
);
